var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideotime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4904_41113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46996 4.14746H12.53M4.96996 1.23079V4.06579M9.02996 1.23079V3.80329M12.8333 5.24996V8.74996C12.8333 8.87829 12.8333 9.00663 12.8216 9.12913C12.5767 8.82721 12.2672 8.58403 11.9159 8.41746C11.5646 8.2509 11.1804 8.16519 10.7916 8.16663C10.1733 8.16663 9.60163 8.38246 9.15246 8.74413C8.84356 8.98825 8.59427 9.29947 8.42347 9.65421C8.25267 10.009 8.16483 10.3979 8.16663 10.7916C8.16663 11.6141 8.53996 12.3433 9.12913 12.8216C9.00663 12.8333 8.87829 12.8333 8.74996 12.8333H5.24996C2.33329 12.8333 1.16663 11.6666 1.16663 8.74996V5.24996C1.16663 2.33329 2.33329 1.16663 5.24996 1.16663H8.74996C11.6666 1.16663 12.8333 2.33329 12.8333 5.24996Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 10.7916C13.4166 11.5791 13.0666 12.2791 12.5241 12.7633C12.0575 13.1658 11.4566 13.4166 10.7916 13.4166C10.1616 13.4166 9.57831 13.195 9.12914 12.8216C8.82723 12.5767 8.58405 12.2672 8.41748 11.9159C8.25092 11.5646 8.1652 11.1804 8.16664 10.7916C8.16664 9.96329 8.54581 9.22246 9.15248 8.74413C9.61675 8.36985 10.1953 8.16602 10.7916 8.16663C11.6141 8.16663 12.3433 8.53996 12.8216 9.12913C13.195 9.57829 13.4166 10.1616 13.4166 10.7916Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.955 9.96912V10.9549L10.1383 11.445",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4904_41113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideotime);
export default __webpack_public_path__ + "static/media/videotime.05b3347b3debb458a1a3cfb9008a6ab6.svg";
export { ForwardRef as ReactComponent };